import {
	ALARM_STATUS,
	DEFAULT_EXCLUSION_FILTERS,
	UNAUTHORIZED_MOVEMENT_ALARMS_GUID,
} from "../../types";
import { Positions } from "../../../../../dashboard/widgets/standard/components/FilterCountCard";
import { uuid } from "../../../../../types/veboxModels";
import { addVeBoxFilter, removeVeBoxFilter } from "../../utils";
import { VeBoxEquipmentFilters } from "../../data/models/VeBoxEquipmentFilters";

export const createDefaultFiltersUtils = (data: uuid[]) => {
	const newFilters: VeBoxEquipmentFilters = {
		alarmFiltersCategory: {
			alarmTypes: [UNAUTHORIZED_MOVEMENT_ALARMS_GUID],
			statuses: [ALARM_STATUS.PENDING.toString()],
			withoutAlarmType: true,
		},
		equipmentStatusesFiltersCategory: {
			equipmentStatuses: data,
		},
		locationFiltersCategory: {
			excludeCategoryGuids: [Positions.UNREGISTERED, Positions.WAREHOUSE],
		},
	};
	return {
		selectedDefaultFilter: [
			DEFAULT_EXCLUSION_FILTERS.IN_UNREGISTERED_LOCATION,
			DEFAULT_EXCLUSION_FILTERS.IN_WAREHOUSE,
			DEFAULT_EXCLUSION_FILTERS.UNAUTHORIZED_MOVEMENT_ALARMS,
			DEFAULT_EXCLUSION_FILTERS.IN_WRITTEN_OFF_OR_MISSING_STATUS,
		],
		newFilters,
	};
};

export const addOrRemoveDefaultFilterUtils = (
	filter: DEFAULT_EXCLUSION_FILTERS,
	selectedDefaultFilter: DEFAULT_EXCLUSION_FILTERS[],
	defaultFilters: VeBoxEquipmentFilters,
	data: string[],
	event,
) => {
	const value = event.target.checked;
	const newFilters: VeBoxEquipmentFilters = {};
	const newSelectedDefaultFilter = value
		? [...selectedDefaultFilter, filter]
		: selectedDefaultFilter.filter(
				(selectedFilter) => selectedFilter !== filter,
			);

	switch (filter) {
		case DEFAULT_EXCLUSION_FILTERS.UNAUTHORIZED_MOVEMENT_ALARMS:
			newFilters.alarmFiltersCategory = {
				alarmTypes: [UNAUTHORIZED_MOVEMENT_ALARMS_GUID],
				statuses: [ALARM_STATUS.PENDING.toString()],
				withoutAlarmType: true,
			};
			break;
		case DEFAULT_EXCLUSION_FILTERS.IN_WRITTEN_OFF_OR_MISSING_STATUS:
			newFilters.equipmentStatusesFiltersCategory = {
				equipmentStatuses: data,
			};
			break;
		case DEFAULT_EXCLUSION_FILTERS.IN_UNREGISTERED_LOCATION:
		case DEFAULT_EXCLUSION_FILTERS.IN_WAREHOUSE:
			return handleLocationFilter(newSelectedDefaultFilter, defaultFilters);
	}

	return {
		newSelectedDefaultFilter,
		defaultFilters: value
			? addVeBoxFilter(defaultFilters, newFilters)
			: removeVeBoxFilter(defaultFilters, newFilters),
	};
};

const handleLocationFilter = (
	selectedDefaultFilter: DEFAULT_EXCLUSION_FILTERS[],
	defaultFilters: VeBoxEquipmentFilters,
) => {
	const filterToRemove: VeBoxEquipmentFilters = {
		locationFiltersCategory: defaultFilters.locationFiltersCategory,
	};
	const newDefaultFilters = removeVeBoxFilter(defaultFilters, filterToRemove);
	const newFilters: VeBoxEquipmentFilters = {
		locationFiltersCategory: { excludeCategoryGuids: [] },
	};
	const includeWarehouse = selectedDefaultFilter.includes(
		DEFAULT_EXCLUSION_FILTERS.IN_WAREHOUSE,
	);
	const includeUnregistered = selectedDefaultFilter.includes(
		DEFAULT_EXCLUSION_FILTERS.IN_UNREGISTERED_LOCATION,
	);

	if (includeWarehouse) {
		newFilters.locationFiltersCategory.excludeCategoryGuids = [
			...newFilters.locationFiltersCategory.excludeCategoryGuids,
			Positions.WAREHOUSE,
		];
	}
	if (includeUnregistered) {
		newFilters.locationFiltersCategory.excludeCategoryGuids = [
			...newFilters.locationFiltersCategory.excludeCategoryGuids,
			Positions.UNREGISTERED,
		];
	}

	return {
		newSelectedDefaultFilter: selectedDefaultFilter,
		defaultFilters: addVeBoxFilter(newDefaultFilters, newFilters),
	};
};
